import React from 'react';
import './Header.css';

const IS_TEST_ENVIRONMENT = false; // Set to false for production

export const Header: React.FC = () => {
  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-brand">
          <img
            src={`${process.env.PUBLIC_URL}/Driscolls-logo.png`}
            alt="Driscoll's"
            className="brand-logo"
          />
          <h1 className="brand-title">Research Cloud Okta</h1>
          {IS_TEST_ENVIRONMENT && (
            <span className="test-environment-badge">
              Test Environment
            </span>
          )}
        </div>
      </div>
    </header>
  );
};
